export type SubscriptionType =
  | 'basic_hosting_support'
  | 'seo_aeo'
  | 'google_ads'
  | 'meta_ads'
  | 'linkedin_ads'
  | 'linkedin_profilpleje'
  | 'maas'
  | 'other';

export type SubscriptionStatus = 'pending_setup' | 'active' | 'paused' | 'cancelling' | 'cancelled';

export type BillingPeriod = 'monthly' | 'quarterly' | 'halvaarlig' | 'yearly';

export type TriggerEvent =
  | 'ved_indgaaelse'
  | 'ved_opstart'
  | 'ved_levering'
  | 'design_godkendt'
  | 'optagelsesdagen'
  | 'custom';

export const SUBSCRIPTION_TYPE_LABEL: Record<SubscriptionType, string> = {
  basic_hosting_support: 'Basic abo',
  seo_aeo: 'SEO/AEO',
  google_ads: 'Google Ads',
  meta_ads: 'Meta',
  linkedin_ads: 'LinkedIn Ads',
  linkedin_profilpleje: 'LinkedIn Profilpleje',
  maas: 'MaaS',
  other: 'Andet',
};

export const SUBSCRIPTION_STATUS_LABEL: Record<SubscriptionStatus, string> = {
  pending_setup: 'Afventer opstart',
  active: 'Aktiv',
  paused: 'Pauset',
  cancelling: 'Opsiges',
  cancelled: 'Opsagt',
};

export const TRIGGER_EVENT_LABEL: Record<TriggerEvent, string> = {
  ved_indgaaelse: 'Ved indgåelse',
  ved_opstart: 'Ved opstart',
  ved_levering: 'Ved levering',
  design_godkendt: 'Design godkendt',
  optagelsesdagen: 'Optagelsesdagen',
  custom: 'Custom',
};

export const BILLING_PERIOD_LABEL: Record<BillingPeriod, string> = {
  monthly: 'Månedligt',
  quarterly: 'Kvartal',
  halvaarlig: 'Halvår',
  yearly: 'År',
};

export interface AdminSubscriptionRow {
  id: string;
  subscription_type: SubscriptionType;
  monthly_price: string;
  billing_period: BillingPeriod;
  contract_length_months: number | null;
  monthly_hour_minimum: string | null;
  status: SubscriptionStatus;
  start_date: string | null;
  end_date: string | null;
  trigger_event: TriggerEvent | null;
  setup_trigger_task_id: string | null;
  contents: unknown;
  cancellation_end_date: string | null;
  cancellation_acknowledged_at: string | null;
  created_at: string;
  client_id: string;
  client_name: string | null;
  sub_rate_fired_at: string | null;
}

export interface AdminSubscriptionDetail {
  subscription: {
    id: string;
    subscription_type: SubscriptionType;
    monthly_price: string;
    setup_fee: string | null;
    billing_period: BillingPeriod;
    contract_length_months: number | null;
    monthly_hour_minimum: string | null;
    contents: unknown;
    start_date: string | null;
    end_date: string | null;
    status: SubscriptionStatus;
    trigger_event: TriggerEvent | null;
    setup_trigger_task_id: string | null;
    created_at: string;
    client_id: string;
    client_name: string | null;
  };
  sub_rate: {
    id: string;
    triggerEvent: string;
    setupTriggerTaskId: string | null;
    setupFee: string;
    firstMonthAmount: string;
    currency: string;
    firedAt: string | null;
    setupInvoiceId: string | null;
    firstMonthInvoiceId: string | null;
  } | null;
  total_invoiced: string;
}
